import { t } from "@/i18n-js/instance";
import { FeatureRow } from "../FeatureRow";
import { SectionWrapper } from "./SectionWrapper";

export const AiAgents = () => (
  <SectionWrapper sectionName={t("pricing_plans.section.ai_agents")}>
    <FeatureRow
      title={t("pricing_plans.feature.chat_agents")}
      basic={false}
      professional={false}
      business={false}
      enterprise
    />

    <FeatureRow
      title={t("pricing_plans.feature.knowledge_engine")}
      basic={false}
      professional={false}
      business={false}
      enterprise
    />

    <FeatureRow
      title={t("pricing_plans.feature.ai_inbox")}
      basic={false}
      professional={false}
      business={false}
      enterprise
    />
  </SectionWrapper>
);
